import OrdersLayout from "./orders-layout";

const Orders = () => <OrdersLayout />;

export default Orders;
export const Component = Orders;
